import { Center, Text } from "@chakra-ui/react"
import * as React from "react"
import { ErrorBoundary as ReactErrorBoundary, FallbackProps } from "react-error-boundary"

interface ErrorBoundaryProps {
  Fallback?: React.ComponentType<FallbackProps>
  children?: React.ReactNode
}

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children, Fallback }) => {
  const handleError = (err: Error) => {
    console.log(err)
    // TODO: sentry
  }
  return (
    <ReactErrorBoundary onError={handleError} FallbackComponent={Fallback || Boundary}>
      {children}
    </ReactErrorBoundary>
  )
}

function Boundary() {
  return (
    <Center minH="100%" minW="100%">
      <Text>Sorry! Something has gone wrong, we have been notified.</Text>
    </Center>
  )
}
